// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"UD-z","smallCardRow":"VD-z","largeCardRow":"WD-z","productSearchRow":"XD-z","curatedRow":"YD-z"};